module.exports = __webpack_public_path__ + "static/media/login_img1.6d0238e1.png";